import {AlmeUIResponse} from "../../../../types/response";


export interface ProcessResponseAction
{
    type: 'CONVERSATION_PROCESS_RESPONSE';
    payload: {
        processedResponseLocation: string;
        response?: AlmeUIResponse;
        messageType?: string;
        error?: boolean;
        errorText?: string;
        statusCode?: number;
    };
}

export function processResponse(
    processedResponseLocation: string,
    response?: AlmeUIResponse,
    messageType?: string,
    error?: boolean,
    errorText?: string,
    statusCode?: number
): ProcessResponseAction
{
    return {
        type: 'CONVERSATION_PROCESS_RESPONSE',
        payload: {
            processedResponseLocation,
            response,
            messageType,
            error,
            errorText,
            statusCode,
        },
    };
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/lib-alme-request/src/actions/actions.ts